import * as React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export default function QboBreadcrums({ children, className }) {
  return (
    <Breadcrumbs
      separator={<KeyboardDoubleArrowRightIcon />}
      aria-label="breadcrumb"
      className={`QboBreadcrumbs__wrapper ${className}`}>
      {children}
    </Breadcrumbs>
  );
}

QboBreadcrums.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

QboBreadcrums.defaultProps = {
  className: '',
};
